export default __webpack_public_path__ + "static/media/business.e7f44737.svg";